import { useTranslation } from "react-i18next"
import { MdAdd, MdAir, MdCloudySnowing, MdOutlineFilterAlt, MdOutlineRemove } from "react-icons/md"
import { Step } from "react-joyride"
import { CustomBodyText, CustomHeader } from "../manualComponets"

const TOOLTIP_W = 524
const PADDING = 12

export function rightOrOverlapFloaterProps(target: string): Step["floaterProps"] {
	const el = document.querySelector(target)
	if (el === null) return {}

	const rect = el.getBoundingClientRect()
	const spaceRight = window.innerWidth - rect.right

	const needed = TOOLTIP_W + PADDING - spaceRight + 20
	const overlap = Math.max(0, needed)

	return {
		disableFlip: true,
		options: {
			modifiers: [
				{ name: "offset", options: { offset: [-overlap, 0] } },
				{ name: "preventOverflow", options: { boundary: "viewport", padding: PADDING } },
			],
		},
	}
}

export const fleetOverviewSteps = (
	translationFunc?: ReturnType<typeof useTranslation>["t"]
): Step[] => {
	const t = translationFunc ?? ((text: string) => text)
	return [
		{
			target: "#map-table",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("fleetOverview.mapTable.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.mapTable.content")}</CustomBodyText>
				</div>
			),
			placement: "right",
			floaterProps: rightOrOverlapFloaterProps("#map-table"),
			disableBeacon: true,
		},
		{
			target: "#fleet-details-arrow-virtual",
			content: (
				<div className={`flex w-112.5 flex-col`}>
					<CustomHeader>{t("fleetOverview.detailsArrow.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.detailsArrow.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			floaterProps: {
				disableFlip: true,
			},
			disableBeacon: true,
		},
		{
			target: "#fleet-search-input",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("fleetOverview.fleetSearchInput.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.fleetSearchInput.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-start",
			disableBeacon: true,
		},
		{
			target: "#header-map-page",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("fleetOverview.headerMapPage.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.headerMapPage.content")}</CustomBodyText>
				</div>
			),
			disableBeacon: true,
		},
		{
			target: "#map-table-pagination",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("fleetOverview.mapTablePagination.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.mapTablePagination.content")}</CustomBodyText>
				</div>
			),
			disableBeacon: true,
		},
		{
			target: "#map-window",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("fleetOverview.mapWindow.header")}</CustomHeader>
					<CustomBodyText>{t("fleetOverview.mapWindow.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			floaterProps: {
				disableFlip: true,
			},
			disableBeacon: true,
		},
		{
			target: "#map-custom-buttons",
			content: (
				<div className={`flex w-150 min-w-150 flex-col`}>
					<CustomHeader>{t("fleetOverview.mapCustomButtons.header")}</CustomHeader>
					<CustomBodyText>
						<span className={`font-semibold`}>
							{t("fleetOverview.mapCustomButtons.zoomButton.label")}
						</span>
						{`: ${t("fleetOverview.mapCustomButtons.zoomButton.start")}`}
						<MdAdd
							className={`bg-dipai-secondary-100 mx-1 inline size-6 rounded-sm border-1 px-0.5 align-middle`}
						/>
						{t("fleetOverview.mapCustomButtons.zoomButton.middle")}
						<MdOutlineRemove
							className={`bg-dipai-secondary-100 mx-1 inline size-6 rounded-sm border-1 px-0.5 align-middle`}
						/>
						{t("fleetOverview.mapCustomButtons.zoomButton.end")} <br />
						<span className={`font-semibold`}>
							{t("fleetOverview.mapCustomButtons.weatherButton.label")}
						</span>
						{`: ${t("fleetOverview.mapCustomButtons.weatherButton.start")}`}
						<MdCloudySnowing
							className={`bg-dipai-secondary-100 mx-1 inline size-6 rounded-sm border-1 px-0.5 align-middle`}
						/>
						{t("fleetOverview.mapCustomButtons.weatherButton.end")} <br />
						<span className={`font-semibold`}>
							{t("fleetOverview.mapCustomButtons.animationButton.label")}
						</span>
						{`: ${t("fleetOverview.mapCustomButtons.animationButton.start")}`}
						<MdAir
							className={`bg-dipai-secondary-100 mx-1 inline size-6 rounded-sm border-1 px-0.5 align-middle`}
						/>
						{t("fleetOverview.mapCustomButtons.animationButton.end")} <br />
						<span className={`font-semibold`}>
							{t("fleetOverview.mapCustomButtons.filtersButton.label")}
						</span>
						{`: ${t("fleetOverview.mapCustomButtons.filtersButton.start")}`}
						<MdOutlineFilterAlt
							className={`bg-dipai-secondary-100 mx-1 inline size-6 rounded-sm border-1 px-0.5 align-middle`}
						/>
						{t("fleetOverview.mapCustomButtons.filtersButton.end")}
					</CustomBodyText>
				</div>
			),
			disableBeacon: true,
		},
	]
}
